import { useHistory } from 'react-router-dom';
import {
	allRoutes,
	level1ContentRoutes,
	level1SettingsRoutes,
	signInRoute,
	signOutRoute,
	homeRoute,
	setupRequiredRoute,
	loginFailedRoute,
	unauthorizedRoute,
	httpErrorRoute,
	pageNotFoundRoute
} from '../routing/routeUtils';
import { useAuthZ } from '../authZ/useAuthZ';

export const useNav = () => {
	const history = useHistory();
	const authZ = useAuthZ();

	//-- Redirects
	const goToSignIn = () => {
		history.push(signInRoute.paths[0]);
	};

	const goToSignOut = () => {
		history.push(signOutRoute.paths[0]);
	};

	const goHome = () => {
		history.push(homeRoute.paths[0]);
	};

	const goToSetupRequired = () => {
		history.push(setupRequiredRoute.paths[0]);
	};

	const goToLoginFailed = () => {
		history.push(loginFailedRoute.paths[0]);
	};

	const goToUnauthorized = () => {
		history.push(unauthorizedRoute.paths[0]);
	};

	const goToHttpError = () => {
		history.push(httpErrorRoute.paths[0]);
	};

	const goToPageNotFound = () => {
		history.push(pageNotFoundRoute.paths[0]);
	};

	const goToPath = (path) => {
		history.push(path);
	};

	//-- Refreshes
	const goToUrl = (path) => {
		const href = window.location.href;
		const baseUrl = href.substr(0, href.lastIndexOf('/'));
		const url = `${baseUrl}/${path}`;
		window.location.href = url;
	};

	//-- Paths
	const getHomePath = () => {
		return homeRoute.paths[0];
	};

	//-- Routes
	const getAllRoutes = () => {
		const routesCurrentUserCanAccess = allRoutes.filter(
			(r) => r.meta.roles.length === 0 || authZ.userIsInRole(r.meta.roles)
		);
		return routesCurrentUserCanAccess;
	};

	const getLevel1ContentRoutes = (isAuthenticated) => {
		const routesCurrentUserCanAccess = level1ContentRoutes.filter(
			(r) =>
				(r.meta.roles.length === 0 || authZ.userIsInRole(r.meta.roles)) && (isAuthenticated || r.meta.secured === false)
		);
		return routesCurrentUserCanAccess;
	};

	const getLevel1SettingsRoutes = () => {
		const routesCurrentUserCanAccess = level1SettingsRoutes.filter(
			(r) => r.meta.roles.length === 0 || authZ.userIsInRole(r.meta.roles)
		);
		return routesCurrentUserCanAccess;
	};

	const getRouteByPath = (path) => {
		const route = allRoutes.find((r) => r.paths.includes(path));
		return route;
	};

	return {
		goToSignIn,
		goToSignOut,
		goHome,
		goToSetupRequired,
		goToLoginFailed,
		goToUnauthorized,
		goToHttpError,
		goToPageNotFound,
		goToPath,
		goToUrl,
		getHomePath,
		getAllRoutes,
		getLevel1ContentRoutes,
		getLevel1SettingsRoutes,
		getRouteByPath
	};
};
